if (!customElements.get("product-low-stock")) {
  customElements.define(
    "product-low-stock",
    class ProductLowStock extends HTMLElement {
      connectedCallback() {
        this.limite = parseInt(this.dataset.limite, 10) || 0;
        this.productId = this.dataset.productId;
        this.textoEl = this.querySelector("[data-low-stock-texto]");

        const dados = this.querySelector("[data-low-stock-estoque]");
        try {
          this.estoque = JSON.parse(dados.textContent);
        } catch (e) {
          this.estoque = {};
        }

        // A troca de cor ou tamanho passa por aqui: cada variante tem o
        // proprio estoque, entao o selo tem que ser recalculado a cada
        // mudanca, e nao so no carregamento.
        if (window.MinimogEvents && this.productId) {
          window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (variant) => {
            this.render(variant && variant.id);
          });
        }

        this.render(this.variantInicial());
      }

      // No carregamento nao existe evento de troca, entao le a variante que a
      // pagina ja vem marcando. Tenta o picker primeiro e cai para o input do
      // formulario, que existe mesmo quando o produto tem uma variante so.
      variantInicial(tentativa = 0) {
        const picker = document.querySelector("variant-picker");
        if (picker && picker.currentVariant) return picker.currentVariant.id;
        const input = document.querySelector('.m-product-form--main [name="id"]');
        if (input && input.value) return Number(input.value);
        if (tentativa < 5) {
          setTimeout(() => this.render(this.variantInicial(tentativa + 1)), 120);
        }
        return null;
      }

      render(variantId) {
        if (!variantId || !this.textoEl) return this.esconde();
        const qtd = this.estoque[String(variantId)];
        if (typeof qtd !== "number" || qtd <= 0 || qtd > this.limite) return this.esconde();

        this.textoEl.textContent =
          qtd === 1
            ? this.dataset.textoUma
            : (this.dataset.textoVarias || "").replace("__N__", qtd);
        this.removeAttribute("hidden");
      }

      esconde() {
        this.setAttribute("hidden", "");
      }
    }
  );
}
